
import React, {useEffect, useState, useRef} from 'react'; 
import { TabView, TabPanel } from 'primereact/tabview';
import FormEdicaoCliente from './FormEdicaoCliente';
import { InputSwitch } from 'primereact/inputswitch';
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Tag } from 'primereact/tag';
import {Icones} from '../../../Componentes/FontConfig'
import FormLocaisInstalacaoCliente from './FormLocaisInstalacaoCliente';
import Conexao from '../../../providers/Conexao';
import FormUsuariosCliente from './FormUsuariosCliente';
import FormLicencasCollector from './FormLicencasCollector';
import { Toast } from 'primereact/toast';

export default function TabClientes(props) {
    const {cliente, visible, setVisible, setCliente} = props;
    const [activeIndex, setActiveIndex] = useState(0);
    const [locaisInstalacao, setLocaisInstalacao] = useState([]);
    const toast = React.useRef(null); // Ref para o Toast
    const [usuarios, setUsuarios] = useState([]);
    const [licencasCollector, setLicencasCollector] = useState([]);
    const [dcas, setDcas] = useState([]);
    const carregadoLocais = useRef(false); // Evita múltiplas chamadas
    const carregadoClientes = useRef(false); // Evita múltiplas chamadas
    const carregadoLicencas = useRef(false); // Evita múltiplas chamadas
  

    const handleTabChange = (e) => {
        setActiveIndex(e.index);
        
       
    };


    useEffect(() => {
        if (!carregadoLocais.current && activeIndex == 1) {
            carregadoLocais.current = true;
            getLocaisByCliente();
        
        }
        props.setIndex(activeIndex)
    }, [activeIndex]); // Executa apenas quando 'cliente' mudar
    
    const getLocaisByCliente = async () => {
        try {
            if(props.setLoading){
                props.setLoading(true)
            }
            const response = await Conexao.post(`LocaisInstalacaoClienteController/getLocaisByCliente?idempresa=${cliente.idempresa}&idcliente=${cliente.idcliente}`);
            setLocaisInstalacao(response.status === 200 && response.data.status === 'OK' ? response.data.payload : []);
            if(props.setLoading){
                props.setLoading(false)
            }
        } catch {
            if(props.setLoading){
                props.setLoading(false)
            }
            setLocaisInstalacao([]);
        }
    };

    useEffect(() => {
        if (!carregadoClientes.current && activeIndex == 2) {
            carregadoClientes.current = true;
 
            getUsuariosCliente();
        }
    }, [activeIndex]); // Executa apenas quando 'cliente' mudar

    const getUsuariosCliente = async () => {
        try {
            if(props.setLoading){
                props.setLoading(true)
            }
            const response = await Conexao.post(`clientesController/getUsuariosCliente?idusuario=${cliente.idusuario}&idempresa=${cliente.idempresa}&idcliente=${cliente.idcliente}`);
            setUsuarios(response.status === 200 && response.data.status === 'OK' ? response.data.payload : []);
            if(props.setLoading){
                props.setLoading(false)
            }
        } catch {
            setUsuarios([]);
            if(props.setLoading){
                props.setLoading(false)
            }
        }
    };



    useEffect(() => {
        if (!carregadoLicencas.current && activeIndex == 3) {
            carregadoLicencas.current = true;
 
            getLicencasCollectorFullData();
        }
    }, [activeIndex]); // Executa apenas quando 'cliente' mudar

     const getLicencasCollectorFullData = async () => {
        try {
            if(props.setLoading){
                props.setLoading(true)
            }
            const response = await Conexao.post('dcaController/getLicencasCollectorFullData',{
                idusuario : cliente.idusuario, 
                idempresa : cliente.idempresa, 
                idcliente : cliente.idcliente
            } );
            if(props.setLoading){
             props.setLoading(false)
            }
            setLicencasCollector(response.status === 200 && response.data.status === 'OK' ? response.data.payload : []);
        } catch {
            setLicencasCollector([]);
            if(props.setLoading){
                props.setLoading(false)
            }
        }
    };


    const getDca = async () => {
        try {
            const response = await Conexao.post('dcaController/getDca',{
                idusuario : cliente.idusuario, 
                idempresa : cliente.idempresa, 
                idcliente : cliente.idcliente
            }                );
            setDcas(response.status === 200 && response.data.status === 'OK' ? response.data.payload : []);
        } catch {
            setDcas([]);
        }
    };


    const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };
    

    return (
        <div className="card">
             <Toast ref={toast} />
            <TabView activeIndex={activeIndex} onTabChange={handleTabChange}>
                <TabPanel header="Opções" leftIcon="pi pi-cog mr-2 text-2xl">
                    <div className="flex flex-wrap gap-1" >
                        {/* Exibindo informações da cliente */}
                        <div className="col-12 md:col-3">
                            <span className="font-medium text-sm">CNPJ/CPF:</span>
                            <div className="text-lg">{cliente.cpf_cnpj}</div>
                        </div>
                        <div className="col-12 md:col-3">
                            <span className="font-medium text-sm">Inscrição Estadual/RG:</span>
                            <div className="text-lg">{cliente.rg_insc}</div>
                        </div>
                        <div className="col-12 md:col-5">
                            <span className="font-medium text-sm">Nome Fantasia/Apelido:</span>
                            <div className="text-lg">{cliente.nomefantasia}</div>
                        </div>

                        <div className="col-12 md:col-2">
                            <span className="font-medium text-sm">CEP:</span>
                            <div className="text-lg">{cliente.cep}</div>
                        </div>

                        <div className="col-12 md:col-7">
                            <span className="font-medium text-sm">Logradouro:</span>
                            <div className="text-lg">{cliente.logradouro}</div>
                        </div>
                        <div className="col-12 md:col-2">
                            <span className="font-medium text-sm">Nº:</span>
                            <div className="text-lg">{cliente.numero}</div>
                        </div>


                        <div className="col-12 md:col-3">
                            <span className="font-medium text-sm">Complemento:</span>
                            <div className="text-lg">{cliente.complemento}</div>
                        </div>
                        <div className="col-12 md:col-3">
                            <span className="font-medium text-sm">Bairro:</span>
                            <div className="text-lg">{cliente.bairro}</div>
                        </div>

                        <div className="col-12 md:col-4">
                            <span className="font-medium text-sm">Cidade:</span>
                            <div className="text-lg">{cliente.cidade}</div>
                        </div>
                           
                        <div className="col-12 md:col-1">
                            <span className="font-medium text-sm">Estado:</span>
                            <div className="text-lg">{cliente.estado}</div>
                        </div>

                        <div className="col-12 md:col-3">
                            <span className="font-medium text-sm">Telefone:</span>
                            <div className="text-lg">{cliente.telefonecomercial}</div>
                        </div>

                        <div className="col-12 md:col-3">
                            <span className="font-medium text-sm">Celular:</span>
                            <div className="text-lg">{cliente.estado}</div>
                        </div>

                        <div className="col-12 md:col-5">
                            <span className="font-medium text-sm">Email:</span>
                            <div className="text-lg">{cliente.email}</div>
                        </div>
                       

                    </div>
                    <div className="grid mt-2"  style={{padding : '8px'}}>
                        

                        <div className="col-12 md:col-6">
                            <Button disabled={props.loading} severity="secondary" className="w-full text-large" label="Fechar" icon={Icones.Fechar} onClick={() => {
                                setCliente([])
                            }} />
                        </div>
                        
                    </div>
                   
                   
                </TabPanel>
                <TabPanel header="Locais" leftIcon="pi pi-building-columns mr-2 text-2xl">
                    <FormLocaisInstalacaoCliente 
                        idempresa ={cliente.idempresa} 
                        idcliente ={cliente.idcliente}
                        idusuario ={cliente.idusuario}
                        fixarCliente ={props.fixarCliente}
                        locaisInstalacao = {locaisInstalacao} 
                        setLocaisInstalacao = {setLocaisInstalacao} 
                        Conexao = {Conexao}
                        showMessageToast={showMessageToast}
                        activeIndex={activeIndex}/>
                </TabPanel>
                <TabPanel header="Usuários" leftIcon="pi pi-calendar mr-2 text-2xl" >
                    <FormUsuariosCliente 
                        idempresa ={cliente.idempresa} 
                        fixarCliente ={props.fixarCliente}
                        idcliente ={cliente.idcliente}
                        idusuario ={cliente.idusuario}
                        usuarios = {usuarios} 
                        Conexao = {Conexao}
                        deleteUser = {(data)=>{
                            setUsuarios(data)
                        }}
                        setUsuarios = {()=>{
                            getUsuariosCliente()
                        }} 
                        showMessageToast={showMessageToast}
                        activeIndex={activeIndex}
                        />
                </TabPanel>
                <TabPanel header="Licenças" leftIcon="pi pi-sitemap mr-2 text-2xl" tooltip='asdas'>
                    <FormLicencasCollector 
                        {...props}
                        idempresa ={cliente.idempresa} 
                        fixarCliente ={props.fixarCliente}
                        idcliente ={cliente.idcliente}
                        idusuario ={cliente.idusuario}  
                        Conexao = {Conexao}                  
                        licencasCollector = {licencasCollector} 
                        setLicencasCollector = {setLicencasCollector} 
                        showMessageToast={showMessageToast}
                        activeIndex={activeIndex}
                        locaisInstalacao = {locaisInstalacao} 
                        getLocaisByCliente ={getLocaisByCliente}
                        />
                </TabPanel>

                



                
                
            </TabView>
        </div>
    )
}
        